import { defineMessages } from '@jutro/locale';

export default defineMessages({
    addLocations: {
        id: 'ml.endorsement.pup.directives.templates.pup-wizard.addLocations',
        defaultMessage: 'Add Locations'
    },
    chooseEffectiveDate: {
        id: 'ml.endorsement.pup.directives.templates.pup-wizard.chooseEffectiveDate',
        defaultMessage: 'Choose Effective Date'
    },
    locations: {
        id: 'ml.endorsement.pup.directives.templates.pup-wizard.locations',
        defaultMessage: 'Locations'
    },
    yourPolicies: {
        id: 'ml.endorsement.pup.directives.templates.pup-wizard.yourPolicies',
        defaultMessage: 'Your Policies'
    },
    addPolicy: {
        id: 'ml.endorsement.pup.directives.templates.pup-wizard.addPolicy',
        defaultMessage: 'Add Policy'
    },
    employerAffiliation: {
        id: 'ml.endorsement.pup.directives.templates.pup-wizard.employerAffiliation',
        defaultMessage: 'Employer/Affiliation'
    },
    drivers: {
        id: 'ml.endorsement.pup.directives.templates.pup-wizard.Drivers',
        defaultMessage: 'Drivers'
    },
    excludedDrivers: {
        id: 'ml.endorsement.pup.directives.templates.pup-wizard.Excluded Drivers',
        defaultMessage: 'Excluded Drivers'
    },
    householdMembers: {
        id: 'ml.endorsement.pup.directives.templates.pup-wizard.Household Members',
        defaultMessage: 'Household Members'
    },
    vehicles: {
        id: 'ml.endorsement.pup.directives.templates.pup-wizard.Vehicles',
        defaultMessage: 'Vehicles'
    },
    watercraft: {
        id: 'ml.endorsement.pup.directives.templates.pup-wizard.Watercraft',
        defaultMessage: 'Watercraft'
    },
    watercraftOperator: {
        id: 'ml.endorsement.pup.directives.templates.pup-wizard.Watercraft Operators',
        defaultMessage: 'Watercraft Operators'
    },
    businessActivity: {
        id: 'ml.endorsement.pup.directives.templates.pup-wizard.Business Activity',
        defaultMessage: 'Business Activity'
    },
    additionalPolicyInfo: {
        id: 'ml.endorsement.pup.directives.templates.pup-wizard.Additional Policy Info',
        defaultMessage: 'Additional Policy Info'
    },
    makeChanges: {
        id: 'ml.gw-portals-policytransaction-pc-pup.Make Changes',
        defaultMessage: 'Make Changes'
    },
    mlQuoteDetails: {
        id: 'ml.endorsement.pup.directives.templates.pup-wizard.Quote Details',
        defaultMessage: 'Quote Details'
    },
    addresses: {
        id: 'ml.endorsement.pup.directives.templates.pup-wizard.Addresses',
        defaultMessage: 'Addresses'
    },
    confirmation: {
        id: 'ml.endorsement.pup.directives.templates.pup-wizard.Policy change confirmation',
        defaultMessage: 'Policy change confirmation'
    },
    loadingPolicyChange: {
        id: 'ml.gw-portals-policytransaction-pc-pup.Loading policy change',
        defaultMessage: 'Loading policy change'
    }
});
